/**
 * Procduct category Reducers
 */
import {
    COLORS,
    COLORS_SUCCESS,
    COLORS_FAILURE,
} from '../actions/action-types';

/**
 * initial state
 */
const INIT_STATE = {
    data: null,
    error: null,
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case COLORS:
            return { ...state, loading: true };

        case COLORS_SUCCESS:
            return { ...state, loading: false, data: action.payload };

        case COLORS_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default: return { ...state };
    }
}
